import { render, staticRenderFns } from "./PoliciesAndContactUs.vue?vue&type=template&id=33896f42&scoped=true&"
import script from "./PoliciesAndContactUs.vue?vue&type=script&lang=js&"
export * from "./PoliciesAndContactUs.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesAndContactUs.vue?vue&type=style&index=0&id=33896f42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33896f42",
  null
  
)

export default component.exports